/**
 * CSS-3D passport card used on the landing hero and the login brand panel.
 * Pure CSS depth (preserve-3d + translateZ layers); the parent may drive the
 * tilt by setting the --rx/--ry custom properties on a wrapping element.
 */

// Deterministic 7×7 pseudo-QR pattern (1 = dark module).
const QR = [
  1, 1, 1, 0, 1, 1, 1, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 0, 0, 0, 1, 0, 0, 0, 1, 1, 0, 1, 1, 0, 1, 1,
  0, 1, 0, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1,
];

export function PassportCard3D({ lang }: { lang: "tr" | "en" }) {
  const tr = lang === "tr";
  return (
    <div className="ld-card3d">
      <div className="c-kicker">Digital Product Passport</div>
      <div className="c-name">Organic Cotton Tee</div>
      <div className="c-sub">GTIN 04012345678925 · {tr ? "Sürüm" : "Version"} 3</div>
      <div className="c-row">
        <div className="ld-qr" aria-hidden="true">
          {QR.map((cell, i) => (
            <i key={i} className={cell === 0 ? "w" : ""} />
          ))}
        </div>
        <div className="c-fields">
          <div>
            <b>{tr ? "Kompozisyon" : "Composition"}</b> · %60 {tr ? "pamuk" : "cotton"}
            <div className="bar" style={{ width: "72%" }} />
          </div>
          <div>
            <b>{tr ? "Geri dönüştürülmüş" : "Recycled"}</b> · %40
            <div className="bar" style={{ width: "46%" }} />
          </div>
          <div>
            <b>CO₂e</b> · 0.31 kg
            <div className="bar" style={{ width: "30%" }} />
          </div>
        </div>
      </div>
      <div className="c-badges">
        <span>GOTS</span>
        <span>OEKO-TEX</span>
        <span>EN 18219</span>
      </div>
      <div className="c-verified">
        <i /> {tr ? "Doğrulanmış — Ed25519 imzalı" : "Verified — Ed25519 signed"}
      </div>
    </div>
  );
}
